import { Component, OnDestroy, OnInit } from '@angular/core';
import { SideNavigationService } from '@sb-tools/typescript/services/side-navigation.service';
import { Location } from '@angular/common';
import { InitializationService } from '../core/services/initialization.service';
import { User } from '../core/models/user.model';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';
import { Subject } from 'rxjs';
import { ComponentMessengerService } from '../core/services/component-messenger.service';
import { environment } from '@environment';
import { AuthenticationService } from '@sb-tools/typescript/authentication/authentication.service';
import { takeUntil } from 'rxjs/operators';
import { CommonDataService } from '@sb-tools/typescript/services/common-data.service';
import { GdprPortalDTO } from '@sb-tools/typescript/models/dto/gdpr-portal.dto';
import { BsDropdownDirective, BsDropdownToggleDirective, BsDropdownMenuDirective } from 'ngx-bootstrap/dropdown';
import { InlineSVGComponent } from '../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { SettingsMenuComponent } from '../../sb-modules/Frontend-Settings-Menu-Module/settings-menu.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    imports: [
        BsDropdownDirective,
        BsDropdownToggleDirective,
        InlineSVGComponent,
        BsDropdownMenuDirective,
        FormsModule,
        ReactiveFormsModule,
        SettingsMenuComponent,
        TranslateModule,
    ],
})
export class NavbarComponent implements OnInit, OnDestroy {
    inboxUrl: string;
    portal: GdprPortalDTO;
    portals: GdprPortalDTO[];
    user: User;
    query = '';
    queryControl = new UntypedFormControl();
    communityName: string;
    newPortalLink: string;

    private unsubscriber = new Subject<void>();

    constructor(
        private sideNavigationService: SideNavigationService,
        public initializationService: InitializationService,
        public authenticationService: AuthenticationService,
        public commonDataService: CommonDataService,
        private location: Location,
        private componentMessengerService: ComponentMessengerService,
    ) {
        this.communityName = this.initializationService.communityName;
        this.newPortalLink = environment.inboxUrl + '/' + this.communityName + '/admin/community/accessRequestPortal';
    }

    ngOnInit() {
        this.inboxUrl = environment.inboxUrl + '/' + this.communityName;
        this.user = this.initializationService.user;
        this.portal = this.initializationService.portal;
        this.portals = this.initializationService.portals;

        this.queryControl.valueChanges
            .pipe(debounceTime(300))
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((newValue) => {
                this.query = newValue;
                this.componentMessengerService.searchQueryUpdated(this.query);
            });
    }

    isRequestsRoute(): boolean {
        try {
            const currentUrlArray = this.location.path().split('?')[0].split('/');
            return currentUrlArray[3].toLowerCase() === 'requests';
        } catch (ex) {}

        return false;
    }

    toggleSidebar(): void {
        this.sideNavigationService.toggleSidebar();
    }

    clearSearchInput(): void {
        this.query = '';
        this.componentMessengerService.searchQueryUpdated(this.query);
    }

    goToPortal(portalName) {
        const url = '/' + this.communityName + '/' + portalName + '/requests';
        window.location.href = url;
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
